import React, { useContext } from "react";
import { store } from "../../components/Store";
import { Link } from "react-router-dom";
import { Accordion } from "../../components/shared/accordion";
import { Icon } from "@iconify/react/dist/iconify.js";
import _ from "lodash";

import { APPS_HELP_DATA } from "../data/apps-help-data";
import { useLanguage } from "../../hooks/use-language";

/**
 * Componente que muestra las preguntas y respuestas correspondientes a las apps
 * @param {object} interfaceTexts - objeto con los textos de interfaz
 * @returns {JSX.Element} AppsHelp
 */
export const AppsHelp = ({ interfaceTexts }) => {

    const infoApps = [...APPS_HELP_DATA];
    const globalState = useContext(store);
    const language = useLanguage();

    return (
        <>
            <Link to={'/ayuda'} className="secondary-button py-2 px-3">
                <Icon icon="material-symbols:arrow-back-rounded" width="24" height="24" />
                {interfaceTexts?.botones?.volver || 'volver'}
            </Link>

            <h2 className="my-4">{interfaceTexts?.apps?.titulo || 'Apps'}</h2>

            <Accordion.Container>
                {
                    infoApps?.map((item) => {
                        return (
                            <Accordion.Item key={item?.id}>
                                <Accordion.ItemButton
                                    className={'acordeon px-3 py-2'}
                                    label={_.get(interfaceTexts, item?.textButton?.translationPath) || item?.textButton?.default}
                                />
                                <Accordion.Content className={'focusable-secondary opcionAcordeon relative'}>
                                    <div key={`video-${item?.id}`} className="w-100">
                                        <iframe
                                            src={_.get(interfaceTexts, item?.video?.translationPath) || item?.video?.default}
                                            title={_.get(interfaceTexts, item?.textButton?.translationPath) || item?.textButton?.default}
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture; fullscreen" allowFullScreen
                                            className='focusable-secondary videoInstruccion'
                                        ></iframe>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Item>
                        )
                    })
                }
            </Accordion.Container>

            <div className="download-apps mt-5">
                <h3>{interfaceTexts?.apps?.descarga || 'Descarga nuestras apps'}</h3>
                <div className="d-flex flex-column flex-md-row justify-content-center align-items-center my-2">
                    <a
                        href="https://apps.apple.com/us/app/makemake-app/id6469707768?platform=iphone"
                        className="focusable-red"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Apple app store"
                    >
                        <img
                            className="img-fluid m-2"
                            style={{ maxWidth: 200 }}
                            src={language === "es" ? "/img/makemake-app/apple-store-badget-ES.png" : "/img/makemake-app/apple-store-badget.png"}
                            alt="apple store"
                        />
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.makemake.app"
                        className="focusable-red"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Play store"
                    >
                        <img
                            className="img-fluid m-2"
                            style={{ maxWidth: 200 }}
                            src={language === "es" ? "/img/makemake-app/google-play-badget-ES.png": "/img/makemake-app/google-play-badget.png"}
                            alt="apple store"
                        />
                    </a>
                </div>
            </div>
        </>
    )
}